import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getWriteEssay = (params) => {
	var url = ApiRouters.WRITEESSAY;
	return api.get(url, { params });
};

export const getWriteEssayDetail = (id, params) => {
	var url = `${ApiRouters.WRITEESSAY}/${id}`;
	return api.get(url, { params });
};

export const createQuesWriteEssay = (body) => {
	var url = ApiRouters.WRITEESSAY;
	return api.post(url, body);
};

export const updateWriteEssayDetail = (body) => {
	var url = `${ApiRouters.WRITEESSAY}/${body.id}`;
	return api.put(url, body);
};

export const deleteWriteEssay = (id) => {
	var url = `${ApiRouters.WRITEESSAY}/${id}`;
	return api.delete(url);
};
